import { openModal, closeModal } from "./modal.js";

const NAV_BREAKPOINT = 1200;
const menu = document.querySelector("#main-navigation");
const hamburger = document.querySelector("#hamburger");
let closeNav = () => {};

if (menu && hamburger) {
  const menuIcon = hamburger.querySelector(".menuIcon");
  const closeIcon = hamburger.querySelector(".closeIcon");

  const subnavs = menu.querySelectorAll(".subnav");
  const subnavCloseButtons = menu.querySelectorAll(".close-subnav");
  const subnavTriggers = Array.from(subnavs)
    .map((subnav) => subnav.previousElementSibling)
    .filter(Boolean);

  const syncSubnavTriggerSwupState = () => {
    const isMobile = window.innerWidth <= NAV_BREAKPOINT;

    subnavTriggers.forEach((trigger) => {
      if (isMobile) {
        trigger.setAttribute("data-no-swup", "");
        return;
      }

      trigger.removeAttribute("data-no-swup");
    });
  };

  const closeSubnav = () => {
    subnavs.forEach((item) => {
      item.classList.add("hidden");
    });
  };

  const openSubnav = (subnav) => {
    if (!subnav) {
      return;
    }

    closeSubnav();
    subnav.classList.remove("hidden");
  };

  const openNav = () => {
    openModal();
    menu.classList.remove("hidden");
    menuIcon?.classList.add("hidden");
    closeIcon?.classList.remove("hidden");
  };

  closeNav = () => {
    closeSubnav();
    closeModal();

    if (window.innerWidth <= NAV_BREAKPOINT) {
      menu.classList.add("hidden");
    }

    menuIcon?.classList.remove("hidden");
    closeIcon?.classList.add("hidden");
  };

  // Toggle nav
  hamburger.addEventListener("click", function () {
    menu.classList.contains("hidden") ? openNav() : closeNav();
  });

  // Close nav on window resize
  window.addEventListener("resize", () => {
    syncSubnavTriggerSwupState();

    if (
      window.innerWidth > NAV_BREAKPOINT &&
      !menu.classList.contains("hidden")
    ) {
      closeNav();
    }
  });

  // Close nav on esc key
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !menu.classList.contains("hidden")) {
      closeNav();
    }
  });

  // Open subnavs
  subnavs.forEach((subnav) => {
    const trigger = subnav.previousElementSibling;

    if (!trigger) {
      return;
    }

    trigger.addEventListener("click", (event) => {
      if (window.innerWidth <= NAV_BREAKPOINT) {
        event.preventDefault();
        event.stopPropagation();
        openSubnav(subnav);
      }
    });
  });

  syncSubnavTriggerSwupState();

  // Close subnavs
  subnavCloseButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      closeSubnav();
    });
  });
}

export { closeNav };
